export const MIN_PAGE_SIZE = 10;
// NB: MAX_PAGE_SIZE is limited by max_per_page in config/initializers/kaminari.rb
export const MAX_PAGE_SIZE = 200;
export const DEFAULT_PAGE_SIZE = 25;
export const PAGE_SIZE_OPTION_1 = 50;
const PAGE_SIZE_OPTION_2 = 100;
export const DEFAULT_PAGE_SIZE_OPTIONS = [
  MIN_PAGE_SIZE,
  DEFAULT_PAGE_SIZE,
  PAGE_SIZE_OPTION_1,
  PAGE_SIZE_OPTION_2,
  MAX_PAGE_SIZE,
];
